import { PostGroupRequest } from '@/coreInfrastructureModule/axios/generated/groupManage';

/**
 * グループ新規作成のアダプタ
 */
export class PostGroupAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param groupName - グループ名
   */
  public static adaptForRequest(groupName: string): PostGroupRequest {
    return {
      postGroupInfo: {
        groupName: groupName,
      },
    };
  }
}
